export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/channel-airline.9dacb128-616031.svg";